var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-col',{attrs:{"sm":"12","md":_vm.col}},[_c('v-card',{staticClass:"fill-height",attrs:{"elevation":_vm.elevation,"loading":_vm.loading}},[_c('Chart',{attrs:{"options":_vm.chartOptions}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }